module.exports = __webpack_public_path__ + "static/img/bg6.027a831b.png";